import * as React from 'react';
import MaterialUIPaper, { PaperProps as MaterialUIPaperProps } from '@material-ui/core/Paper';
import { CircularProgress } from './CircularProgress';
import { createStyles, Theme, withStyles, WithStyles, withTheme, WithTheme } from '@material-ui/core/styles';
import { ErrorIcon } from './ErrorIcon';
import { Overlay } from './Overlay';

export type PaperProps = {
  hasError?: boolean;
  isLoading?: boolean;
  removePadding?: boolean;
  mainContainer?: boolean;
  noFlex?: boolean;
};

const styles = (theme: Theme) =>
  createStyles({
    paper: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      position: 'relative'
    },
    icon: {
      position: 'absolute',
      top: theme.spacing(4),
      left: '50%',
      margin: `-${theme.spacing(2)}px 0 0 -${theme.spacing(2)}px`,
      zIndex: theme.zIndex.appBar
    }
  });

type Props = WithStyles<typeof styles> & WithTheme & MaterialUIPaperProps & PaperProps;

const PaperComponent: React.FC<Props> = ({
  classes,
  children,
  className = '',
  hasError,
  isLoading,
  theme,
  removePadding,
  mainContainer,
  noFlex,
  ...paperProps
}) => {
  const Icon = hasError ? ErrorIcon : isLoading ? CircularProgress : undefined;
  return (
    <MaterialUIPaper
      style={{
        minHeight: Icon && theme.spacing(8),
        padding: removePadding ? 0 : `${theme.spacing()}px ${theme.spacing(1.5)}px ${theme.spacing(1.5)}px`,
        margin: mainContainer ? `${theme.spacing(3)}px ${theme.spacing(2)}px` : 0
      }}
      className={`${noFlex ? '' : classes.paper} ${className}`}
      {...paperProps}
    >
      {Icon && (
        <React.Fragment>
          <Icon className={classes.icon} />
          <Overlay open />
        </React.Fragment>
      )}
      {children}
    </MaterialUIPaper>
  );
};

export const Paper = withStyles(styles)(withTheme(PaperComponent));
